<template>
  <div class="box_column">
    <Breadcrumb title="账户管理" :breadcrumb="breadcrumb" />
    <div class="content">
      <blue-title>{{ title[0] }}</blue-title>
      <!-- 账号信息 -->
      <Account v-if="title[0] === '账号信息'"></Account>
      <!-- 编辑角色 -->
      <editRole v-else></editRole>
      <blue-title>{{ title[1] }}</blue-title>
      <!-- 权限信息 -->
      <Limit></Limit>
    </div>
  </div>
</template>

<script>
import Account from '@account/components/personal/account';
import Limit from '@account/components/personal/limit';
import editRole from '@account/components/role/editRole';
import { openDialog } from '@account/static/mixin.js';
import { breadcrumb } from '@/mixins/index.js';
import { titleName } from '@account/static/data.js';
export default {
  mixins: [breadcrumb, openDialog],
  components: {
    Account,
    Limit,
    editRole,
  },
  computed: {
    title() {
      return titleName.get(this.$route.name);
    },
  },
  provide() {
    return {
      edit: this.editAccount,
    };
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.box_column {
  height: 100%;
}
.content {
  flex: 1;
  background: @bg-white;
  padding-top: 20px;
}
</style>
